import { useAssignmentRequestsGetAssignmentRequest } from 'api/assignment-requests/assignment-requests';
import LoadingSpinner from 'components/spinners/LoadingSpinner';
import React from 'react';
import AssignmentRequestModal from './AssignmentRequestModal';
import Modal from 'components/Modal';

interface Props {
  requestId: number;
  onClose: () => void;
}

const AssignmentRequestModalWrapper: React.FC<Props> = ({
  requestId,
  onClose,
}) => {
  const getExtendedAssignmentRequestCall =
    useAssignmentRequestsGetAssignmentRequest({
      id: requestId,
    });

  if (!getExtendedAssignmentRequestCall.data) {
    return (
      <Modal>
        <LoadingSpinner>Laddar förfrågan...</LoadingSpinner>
      </Modal>
    );
  }

  return (
    <AssignmentRequestModal
      request={getExtendedAssignmentRequestCall.data}
      onClose={onClose}
    />
  );
};

export default AssignmentRequestModalWrapper;
